import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Imgplc from "../assets/imgplace.png";
import Imgplc2 from "../assets/placeholder-600x400.webp";
import useImageFallback from "../hooks/useImageFallback";

const Img = ({ src, className, alt, skipCloudfront, onError, ...props }) => {
  const { currentSrc, handleError } = useImageFallback(src, {
    skipCloudfront,
    onFinalError: (e, failedSrc) => {
      if (onError) return onError(e, failedSrc);
      e.target.onerror = null;
      e.target.src = Imgplc2;
    },
  });

  return (
    <LazyLoadImage
      alt={alt}
      effect="blur"
      src={currentSrc}
      placeholderSrc={Imgplc}
      className={className}
      onError={handleError}
      loading="lazy"
      {...props}
    />
  );
};

export default Img;
